/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title-right[_nghost-%COMP%]   .header[_ngcontent-%COMP%]{text-align:right}.header[_ngcontent-%COMP%]{color:#8c0000;font-size:14px;cursor:pointer;padding:10px 0}.header[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{margin-right:5px}.content[_ngcontent-%COMP%]{overflow:hidden}.content.expanded[_ngcontent-%COMP%]{overflow:visible}"];
export { styles as styles };
